import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/custom.scss';
import './assets/css/project.scss';
import './assets/css/ReactToastify.scss';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import AuthRoute from './AuthRoute';
import store from './redux/store';
import mainTheme from './theme/theme';
import Loader from './CommonComponents/Loader'
import Footer from './CommonComponents/Footer'
import RootRouter from './RootRouter';
import ErrorDialog from './CommonComponents/ErrorDialog';

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={mainTheme}>
          <RootRouter AuthRoute={AuthRoute} />
          <ToastContainer />
          <Loader />
          <Footer />
          <ErrorDialog />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}

export default App;
